import {styled} from "styled-components";


const Button = styled.button`
  display: inline-block;
  vertical-align: middle;
  width: 100%;
  padding: 0;
  outline: none;
  border: 0;
  background-color: transparent;
  cursor: pointer;
  box-sizing: border-box;
`

const UiButton = ({type, text = '', onClick = () => {}, disabled, className=''}) => {

    return (
        <Button
            type={type}
            onClick={onClick}
            disabled={disabled}
            className={className}
        >{text}</Button>
    )
}

export default UiButton;